module.exports = __webpack_public_path__ + "img/forgotten_password.ad362ab5.svg";